import { ElasticQuery } from "types/gql-types";
import { formatFilters, useSidebarFilters } from "../sidebar-filters";

// Single source of truth for the toolbar's bulk-action scoping, shared by
// button-action, the toolbar status change, and the group-message modal so a
// new elasticQuery field never has to be hand-threaded into each one again.
//
// HAV-162: page-range bulk scopes are sliced server-side by this sort, so every
// bulk elasticQuery must carry the table's active order or page ranges resolve
// against a different order than the one on screen.
export const useBulkElasticQuery = (defaultSorting?: string): ElasticQuery => {
  const { filterState, textFilter, filterCondition } = useSidebarFilters();
  return {
    filters: formatFilters(filterState),
    ...(filterCondition ? { filterCondition } : {}),
    textFilter,
    defaultSorting,
  };
};

type BulkScope = {
  interestIds: string[] | null;
  elasticQuery: ElasticQuery | null;
};

// "All selected" and page-range selections scope by query; explicit row
// selections scope by id. Exactly one of the two fields is non-null.
export const getScope = (
  withQuery: boolean,
  elasticQuery: ElasticQuery | null,
  interestIds: string[],
): BulkScope => ({
  interestIds: withQuery ? null : interestIds,
  elasticQuery: (withQuery && elasticQuery) || null,
});
